module.exports = __webpack_public_path__ + "img/bgimg00.eaa86d13.png";